import * as React from 'react';

var _circle, _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgPlume = function SvgPlume(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 48 48"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 24,
        cy: 24,
        r: 24,
        fill: "#FF3D00"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M11.25 11.252v10.065l3.593 3.597V14.849l10.015.033-3.591-3.598-10.015-.034zm18.22 8.05v9.087l-3.592-3.597v-9.087zM19.455 29.335h9.072l-3.59-3.599h-9.073zm15.123 4.123v-9.041l-3.593-3.597v10.065l-10.015-.034 3.591 3.599 9.057.03 1.91 1.913 1.223.175-.233-1.166z",
        clipRule: "evenodd"
    })));
};

export { SvgPlume as ReactComponent };
//# sourceMappingURL=PLUME.svg.es.js.map
